import React from 'react';
import {
  Button, Col, Row,
} from 'reactstrap';
import { Link } from 'react-router-dom';
import {
  Auth, Form, TextField, Intl,
} from 'components';
import { composeValidators, equalTo, required } from 'config/InputErrors';

export default React.memo( ( { dataSubmitted, onSubmit } ) => (
  <Auth>
    {dataSubmitted
      ? (
        <div className="text-center">
          <i className="far fa-check-circle fa-4x text-gray-7 mb-3" />
          <p className="text-gray-7">
            <Intl id="recoverPasswordDone" />
          </p>
          <p>
            <Link
              to="/"
              className="text-lg lh-130 btn btn-app-default btn-app-sm"
            >
              <Intl id="login" />
            </Link>
          </p>
        </div>
      )
      : (
        <>
          <p className="m-0">
            <Intl id="resetPasswordTitle" />
          </p>
          <p className="text-gray-7">
            <Intl id="resetPasswordSubtitle" />
          </p>
          <Row>
            <Col lg="5" md="7">
              <Form
                onSubmit={onSubmit}
                showErrorsInHeader
              >
                <>
                  <TextField
                    field="password"
                    label="newPassword"
                    validate={required}
                    type="password"
                    labelClass="required"
                  />
                  <TextField
                    field="passwordConfirmation"
                    label="passwordConfirmation"
                    validate={composeValidators( required, equalTo( 'password' ) )}
                    type="password"
                    labelClass="required"
                    validateTranslateValues={{ label: <Intl id="newPassword" /> }}
                  />
                </>

                <div className="text-center mt-4">
                  <Button color="app-default" size="app-sm" className="font-weight-700">
                    <Intl id="resetPassword" />
                  </Button>
                </div>
              </Form>
            </Col>
          </Row>
        </>
      )}
  </Auth>
) );
